import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  IconCardLinkSupportPunish,
  IconCardLinkSupportQuestion,
  IconCardLinkSupportService,
  IconNopPhatNguoi
} from '../../../assets/icons'
import BaseTitle from '../../BasicComponent/BaseTitle'
import BaseBottomSheetPopup from '../../BasicComponent/BaseBottomSheetPopup'
import SupportCenterPopup from '../../BasicComponent/SupportCenterPopup'
import './index.scss'
import { PATH } from '../../../constants/router'

export default function CardIconsLinkSupport() {
  const history = useHistory()
  const [isOpenSupportCenterPopup, setIsOpenSupportCenterPopup] = useState(false)

  const [isOpenPunishPopup, setIsOpenPunishPopup] = useState(false)
  const icons = [
    {
      key: 1,
      icon: <IconCardLinkSupportQuestion />,
      link: '',
      onClick: () => {
        history.push(PATH.TRAFFIC_FINE_FAQ)
      },
      text: 'Các câu hỏi thường gặp'
    },
    {
      key: 2,
      icon: <IconCardLinkSupportPunish />,
      link: '',
      onClick: () => {
        setIsOpenPunishPopup(true)
      },
      text: 'Nộp phạt nguội'
    },
    {
      key: 3,
      icon: <IconCardLinkSupportService />,
      link: '',
      onClick: () => {
        setIsOpenSupportCenterPopup(true)
      },
      text: 'Yêu cầu hỗ trợ'
    }
  ]

  const handleOpenLink = (link) => {
    if (!link) return

    const newTab = window.open(link, '_blank', 'noopener,noreferrer')

    if (!newTab) {
      const a = document.createElement('a')
      a.href = link
      a.target = '_blank'
      a.rel = 'noopener noreferrer'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }

  return (
    <div>
      <BaseTitle>Hỗ trợ</BaseTitle>
      <div className="CardIconsLinkSupport">
        {icons.map((item) => {
          if (item.link) {
            return (
              <button
                key={item.key}
                type="button"
                className="CardIconsLinkSupport_item"
                onClick={() => handleOpenLink(item.link)}>
                <div className="CardIconsLinkSupport_item_icon">{item.icon}</div>
                <div className="CardIconsLinkSupport_item_text">{item.text}</div>
              </button>
            )
          }

          return (
            <button key={item.key} type="button" className="CardIconsLinkSupport_item" onClick={item.onClick}>
              <div className="CardIconsLinkSupport_item_icon">{item.icon}</div>
              <div className="CardIconsLinkSupport_item_text">{item.text}</div>
            </button>
          )
        })}
      </div>
      <SupportCenterPopup open={isOpenSupportCenterPopup} onClose={() => setIsOpenSupportCenterPopup(false)} />

      <BaseBottomSheetPopup open={isOpenPunishPopup} onClose={() => setIsOpenPunishPopup(false)} title="Nộp phạt nguội">
        <div className="CardIconsLinkSupport_punishPopupContent">
          <div className="CardIconsLinkSupport_punishPopupContent_icon">
            <IconNopPhatNguoi />
          </div>
          <div className="CardIconsLinkSupport_punishPopupContent_text">
            Bạn vui lòng truy cập vào trang web Cổng Dịch vụ công Quốc gia hoặc đến trực tiếp Cơ quan Công an để nộp phạt nguội.
          </div>
        </div>
      </BaseBottomSheetPopup>
    </div>
  )
}
